import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from '@/locales/en'
import zhCN from '@/locales/zh-CN'
import ja from '@/locales/ja'

Vue.use(VueI18n)

const STORAGE_KEY = 'sm-lang'

function getInitialLocale() {
  try {
    const s = localStorage.getItem(STORAGE_KEY)
    if (s === 'zh-CN' || s === 'en' || s === 'ja') return s
  } catch (e) {
    /* ignore */
  }
  return 'zh-CN'
}

const i18n = new VueI18n({
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages: {
    en,
    'zh-CN': zhCN,
    ja,
  },
})

export function setI18nLocale(code) {
  if (code !== 'zh-CN' && code !== 'en' && code !== 'ja') return
  i18n.locale = code
  try {
    localStorage.setItem(STORAGE_KEY, code)
  } catch (e) {
    /* ignore */
  }
}

export { STORAGE_KEY }
export default i18n
